import React, { useEffect, useState } from "react";
import {
  TeachingPopover,
  TeachingPopoverBody,
  TeachingPopoverHeader,
  TeachingPopoverTitle,
  TeachingPopoverSurface,
  TeachingPopoverTrigger,
  TeachingPopoverFooter,
  Avatar,
} from "@fluentui/react-components";
import {
  Cross,
  DismissCircleIcon,
  DismissSvg,
} from "../../modules/default-svg";
import CustomInput from "../controls/input/customInput/CustomInput";
import CustomButton from "../controls/button/Button";

const HourlyEstimation = ({ TriggerBtn, item, updateResourceCapacity }) => {
  const [capacity, setCapacity] = useState(item.estimatedEffort);
  const [open, setOpen] = useState(false);

  const changeCapacity = (e) => {
    setCapacity(e);
  };

  const updateCapacity = () => {
    item.estimatedEffort = capacity;
    updateResourceCapacity(item);
    setCapacity(item.estimatedEffort);
    setOpen(!open);
  };

  const onOpenChange = () => {
    setOpen(!open);
  };

  useEffect(() => {
    setCapacity(item.estimatedEffort);
  }, [item.estimatedEffort]);

  return (
    <TeachingPopover
      positioning="below-start"
      withArrow={false}
      open={open}
      onOpenChange={onOpenChange}
    >
      <TeachingPopoverTrigger>{TriggerBtn}</TeachingPopoverTrigger>
      <TeachingPopoverSurface className="HourlyEstimateWrap">
        <TeachingPopoverBody>
          <div className="d-flex align-items-center justify-content-between">
            <p className="text-xsm-600 AvatarColor">Update hourly estimation</p>
            <span onClick={onOpenChange}>
              <Cross />
            </span>
          </div>
          <div className="HourlyEstimateBody">
            <div className="d-flex flex-column align-items-center userWrap">
              <Avatar
                color="colorful"
                name={item.label}
                image={{ src: item.image }}
              />
              <p
                className="text-xsm-400 textColor1 mt-1 text-nowrap text-truncate text-center"
                style={{ width: "80px" }}
              >
                {item.label}
              </p>
            </div>
            <div className="">
              <CustomInput value={capacity} handleChange={changeCapacity} />
            </div>
          </div>
          <CustomButton
            label="Update"
            btnClass="HourlyEstimateBtn"
            clickHandler={updateCapacity}
          />
        </TeachingPopoverBody>
      </TeachingPopoverSurface>
    </TeachingPopover>
  );
};

export default HourlyEstimation;
